import FactCheckIcon from "@mui/icons-material/FactCheck";
import { tenants } from "utils/tenants";
import { resources as InternshipSessions } from "./InternshipSessions";
import { resources as InternshipPlans } from "./InternshipPlans";
import { resources as ScheduleCycleStream } from "./ScheduleCycleStream";
import { resources as ScheduleIndividualSlot } from "./ScheduleIndividualSlot";
import { resources as ScheduleFreeSelectionSlot } from "./ScheduleFreeSelectionSlot";
import { resources as InternshipStateExams } from "./InternshipStateExams";
import { resources as TrainingBase } from "./TrainingBase";
import { resources as InternshipStudents } from "./InternshipStudents";
import { resources as ScheduleIndividualCycle } from "./ScheduleIndividualCycle";
import { resources as ThesisDefense } from "./ThesisDefense";
import { resources as GraduatedStudentDocuments } from "./GraduatedStudentDocuments";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <FactCheckIcon />,
  name: "Дипломиране",
  title: "Дипломиране",
  subMenu: [
    InternshipSessions,
    InternshipPlans,
    InternshipStudents,
    InternshipStateExams,
    ThesisDefense,
    TrainingBase,
    ScheduleCycleStream,
    ScheduleIndividualCycle,
    ScheduleIndividualSlot,
    ScheduleFreeSelectionSlot,
    GraduatedStudentDocuments,
  ],
};
